var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
export var SkipLink = function (_a) {
    var _b = _a.translateY, translateY = _b === void 0 ? '-translate-y-16' : _b;
    return (_jsx("a", __assign({ className: clsx('transition left-0 top-0 rounded-full text-shoe-950 bg-squash', 'hover:bg-squash-500 hover:text-shoe absolute p-3 m-3', 'focus:translate-y-0 z-[100]', translateY), href: "#main-content" }, { children: "Skip to main content" })));
};
